import { DOCS_URL } from "../../../config/constants.js";
import { ETitleFontSizes } from "../../../config/enums.js";
import FeatureSlider from "./FeatureSlider.svelte";

export default {
    component: FeatureSlider,
    name: "Feature Slider",
    description: "Carousel",
    docsLink: `${DOCS_URL}/storybook/?path=/docs/molecules-featureslider--docs`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/slideshow.svg",
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2F923eeffdff764c1a8b9c81ee7722b48c",
    inputs: [
        {
            friendlyName: "Background Colour",
            name: "backgroundColour",
            type: "color",
        },
        {
            friendlyName: "Text Colour",
            name: "txtColour",
            type: "color",
        },
        {
            name: "slides",
            type: "list",
            subFields: [
                {
                    friendlyName: "Title",
                    name: "title",
                    type: "text",
                },
                {
                    friendlyName: "Heading Level (Semantic)",
                    name: "headingLevel",
                    type: "text",
                    enum: ["h1", "h2", "h3", "h4", "h5", "h6"],
                    defaultValue: "h3",
                    helperText: "Select the semantic HTML heading level for SEO and accessibility",
                },
                {
                    friendlyName: "Title Font Size",
                    name: "titleSize",
                    type: "text",
                    enum: Object.values(ETitleFontSizes),
                    defaultValue: ETitleFontSizes.H3,
                },
                {
                    friendlyName: "Text",
                    name: "text",
                    type: "longText",
                },
                // ImageInputsTemplate <-- see this template
                {
                    friendlyName: "Image",
                    name: "image",
                    type: "object",
                    helperText: "16:9 Aspect Ratio",
                    subFields: [
                        {
                            friendlyName: "Source",
                            name: "src",
                            type: "file",
                            allowedFileTypes: ["jpg", "webm", "gif", "png"],
                            defaultValue: "https://placehold.co/400",
                        },
                        {
                            friendlyName: "Alt",
                            name: "alt",
                            type: "text",
                        },
                    ],
                },
            ],
        },
    ],
};
